// src/components/shared/forms/specialized/CurrencyInput.jsx
import React from 'react';
import { TextInput } from '../FormComponents';

export const CurrencyInput = ({ 
  value = '', 
  onChange, 
  currency = 'ZAR',
  disabled = false,
  min,
  max,
  placeholder = "0.00"
}) => {
  const getCurrencySymbol = (curr) => {
    const symbols = { ZAR: 'R', USD: '$', EUR: '€', GBP: '£' };
    return symbols[curr] || 'R';
  };

  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500">
        {getCurrencySymbol(currency)}
      </span>
      <TextInput
        value={value}
        onChange={onChange}
        type="number"
        min={min}
        max={max}
        step="0.01"
        disabled={disabled}
        className="pl-8"
        placeholder={placeholder}
      />
    </div>
  );
};